import { IconContent } from '@icons';

export const chart: IconContent = {
    md: '<path d="m18.87 7.54-3.44 5.29-4.78-2.43-2.94 4.53-.84-.54 3.44-5.3 4.77 2.44 2.95-4.54.84.55Z"/><path d="M5.5 5.5v12h14v1h-15v-13h1Z"/>',
};
